import {gql} from '@apollo/client';
import {STAFF} from '../../graphql/fragments';

export const BULK_UPDATE_ACCOUNTS = gql`
  mutation UpdateBulkAdmin(
    $actionList: [ActionEnum]!
    $additionalData: AdditionalData
    $idList: [UUID]!
  ) {
    bulkUpdateAccounts(
      actionList: $actionList
      additionalData: $additionalData
      idList: $idList
    ) {
      ok
      errors
    }
  }
`;

export const PULL_ACCOUNT = gql`
  mutation PullAccount($id: UUID!) {
    pullAccount(id: $id) {
      account {
        id
        name
        contacts {
          id
          name
        }
        propositionType
        adviser {
          id
          name
          email
        }
        owner {
          id
          name
          email
        }
      }
    }
  }
`;

export const BulkAccountFragment = gql`
  fragment BulkAccountFragment on BulkContactType {
    id
    accountId
    contactId
    clientName
    accountName
    nextReviewDate
    meetingBookedDate
    atrDate
    atrMostRecentlySent
    atrLastUpdated
    atrScore
    cqUpdated
    fpaComplete
    portalAccess {
      status
      lastUpdated
    }
    canRequestFpa {
      isAllowed
      disallowedReason
    }
    canRequestAtr {
      isAllowed
      disallowedReason
    }
    canRequestCq {
      isAllowed
      disallowedReason
    }
    propositionType
    adviser {
      id
      name
      email
    }
    owner {
      id
      name
      email
    }
  }
`;

export const GET_BULK_ACCOUNTS = gql`
  query GetBulkAccounts(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $searchTerm: String
    $orderBy: BulkAdminSortableFieldsEnum
    $orderDirection: SortingDirectionEnum
    $adviserEmails: [String!]
    $ownerEmails: [String!]
    $propositionTypes: [SelectPropositionTypeEnum!]
    $nextReviewDateRange: DateRangeInput
    $lastAtrDateRange: DateRangeInput
    $cqUpdatedDateRange: DateRangeInput
    $noAdviser: Boolean
  ) {
    bulkAccounts(
      before: $before
      after: $after
      first: $first
      last: $last
      searchTerm: $searchTerm
      orderBy: $orderBy
      orderDirection: $orderDirection
      adviserEmails: $adviserEmails
      ownerEmails: $ownerEmails
      propositionTypes: $propositionTypes
      nextReviewDateRange: $nextReviewDateRange
      lastAtrDateRange: $lastAtrDateRange
      cqUpdatedDateRange: $cqUpdatedDateRange
      noAdviser: $noAdviser
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          ...BulkAccountFragment
        }
      }
    }
  }
  ${BulkAccountFragment}
`;

export const GET_ALL_ADMINS = gql`
  ${STAFF}
  query GetAllAdmins {
    staff(staffType: "administrator") {
      ...Staff
    }
  }
`;

export const GET_ALL_SERVICE_MANAGERS = gql`
  ${STAFF}
  query GetAllServiceManagers {
    staff(staffType: "service_manager") {
      ...Staff
    }
  }
`;

export const GET_ALL_SUPERVISORS = gql`
  ${STAFF}
  query GetAllSupervisors {
    staff(staffType: "supervisor") {
      ...Staff
    }
  }
`;

export const GET_ALL_PARAPLANNERS = gql`
  ${STAFF}
  query GetAllParaplanners {
    staff(staffType: "paraplanner") {
      ...Staff
    }
  }
`;

export const GET_ALL_CASE_CHECKERS = gql`
  ${STAFF}
  query GetAllCaseCheckers {
    staff(staffType: "case_checker") {
      ...Staff
    }
  }
`;

export const GET_ALL_SENIOR_ADVISERS = gql`
  ${STAFF}
  query GetAllSeniorAdvisers {
    seniorAdvisers {
      ...Staff
    }
  }
`;
